<template>
  <v-card class="my-2">
    <v-card-title class="title">
      Social Media
      <v-spacer />
      <v-dialog v-model="editing" max-width="600px" v-if="edit">
        <v-btn color="secondary darken-2" slot="activator">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
        <v-card>
          <v-card-title> Update Social Media Information</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-form v-model="valid" style="width: 100%">
                <v-text-field
                  label="Facebook"
                  prepend-icon="mdi-facebook"
                  type="search"
                  v-model="modified.facebook"
                />
                <v-text-field
                  label="Twitter"
                  prepend-icon="mdi-twitter"
                  type="search"
                  v-model="modified.twitter"
                />
                <v-text-field
                  label="Linkedin"
                  prepend-icon="mdi-linkedin"
                  type="search"
                  v-model="modified.linkedin"
                />
                <v-text-field
                  label="Website"
                  prepend-icon="mdi-web"
                  type="search"
                  v-model="modified.website"
                />
              </v-form>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat @click="cancel" color="secondary">Cancel</v-btn>
            <v-btn @click="update" :disabled="!valid" color="accent darken-2">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap align-content-space-around justify-center>
        <v-flex child-flex class="text-xs-center" v-if="organization.facebook">
          <v-btn flat :icon="$vuetify.breakpoint.smAndDown" :href="organization.facebook">
            <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-facebook</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">Facebook</span>
          </v-btn>
        </v-flex>
        <v-flex child-flex class="text-xs-center" v-if="organization.twitter">
          <v-btn flat :icon="$vuetify.breakpoint.smAndDown" :href="organization.twitter">
            <v-icon left>mdi-twitter</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">Twitter</span>
          </v-btn>
        </v-flex>
        <v-flex child-flex class="text-xs-center" v-if="organization.linkedin">
          <v-btn flat :icon="$vuetify.breakpoint.smAndDown" :href="organization.linkedin">
            <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-linkedin</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">LinkedIn</span>
          </v-btn>
        </v-flex>
        <v-flex child-flex class="text-xs-center" v-if="organization.website">
          <v-btn flat :icon="$vuetify.breakpoint.smAndDown" :href="organization.website" target="_blank">
            <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-web</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">Website</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      valid: false,
      errors: {},
      modified: {
        facebook: this.organization.facebook || '',
        twitter: this.organization.twitter || '',
        linkedin: this.organization.linkedin || '',
        website: this.organization.website || ''
      }
    }
  },
  methods: {
    cancel() {
      this.modified.facebook = this.organization.facebook
      this.modified.twitter = this.organization.twitter
      this.modified.linkedin = this.organization.linkedin
      this.modified.website = this.organization.website
      this.editing = false
      this.errors = {}
    },
    update() {
      Object.assign(this.organization, this.modified)
      // console.log(this.organization)
      this.$store.dispatch('client/organization/update', this.organization).then(errors => {
        if (errors) {
          this.errors = errors
          this.$store.dispatch('snackbarError', 'Could not be updated at this time')
        } else {
          this.$store.dispatch('snackbarSuccess', 'Updated successfully')
          this.editing = false
        }
      })
    }
  }
}
</script>
